import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IRevolvingAccountStatusFormMeta {
    delayPayment: FormInputMeta;
    delayPaymentDate: FormInputMeta;
    outstandingNumber: FormInputMeta;
    outstandingNumberDate: FormInputMeta;
    depPLCredit: FormInputMeta;
    depPLCreditDate: FormInputMeta;
    administrativeStatus: FormInputMeta;
    administrativeStatusDate: FormInputMeta;
    reasonStatus: FormInputMeta;

    schema: any;
}

const revolvingAccountStatusFormMeta = {} as IRevolvingAccountStatusFormMeta;

revolvingAccountStatusFormMeta.delayPayment = {
    name: "delayPayment",
    type: "checkbox",
    label: "Retard Paiement",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.delayPaymentDate = {
    name: "delayPaymentDate",
    type: "date",
    label: "Date",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.outstandingNumber = {
    name: "outstandingNumber",
    type: "select",
    label: "Numéro Impayé",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.outstandingNumberDate = {
    name: "outstandingNumberDate",
    type: "date",
    label: "Date",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.depPLCredit = {
    name: "depPLCredit",
    type: "checkbox",
    label: "Dép, PL, Crédit",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.depPLCreditDate = {
    name: "depPLCreditDate",
    type: "date",
    label: "Date",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.administrativeStatus = {
    name: "administrativeStatus",
    type: "select",
    label: "Statut Administratif",
    placeholder: "",
    validation: yup.string()
};

revolvingAccountStatusFormMeta.administrativeStatusDate = {
    name: "administrativeStatusDate",
    type: "date",
    label: "Date",
    placeholder: "",
    validation: yup.boolean()
};

revolvingAccountStatusFormMeta.reasonStatus = {
    name: "reasonStatus",
    type: "text",
    label: "Statut Motif",
    placeholder: "",
    validation: yup.string()
};


revolvingAccountStatusFormMeta.schema = yup.object().shape(getValidationSchema(revolvingAccountStatusFormMeta));

export default revolvingAccountStatusFormMeta;